import { render, staticRenderFns } from "./DeveloperEmail.vue?vue&type=template&id=8c24537c"
import script from "./DeveloperEmail.vue?vue&type=script&lang=js"
export * from "./DeveloperEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports